import { List, ListItem, ListItemText } from "@mui/material";
import { Alert, AlertTitle } from "@mui/material";
import { CSSProperties } from "react";

export function ErrorsAlert(props: { title: string; messages: string[]; style?: CSSProperties; className?: string }) {
    if (!props.messages?.length) return null;

    return (
        <Alert style={props.style} className={props.className} severity="error">
            <AlertTitle>{props.title}</AlertTitle>
            <List>
                {props.messages.map((message, index) => (
                    <ListItem key={index}>
                        <ListItemText primary={message} />
                    </ListItem>
                ))}
            </List>
        </Alert>
    );
}
